import 'react-phone-input-2/lib/style.css';
import Form from '../form/Form';
import PhoneInput from 'react-phone-input-2';
import ReCAPTCHA from 'react-google-recaptcha';
import style from './contact.module.css';

const Contact = ({ visibleElements, elementsRef }) => {
    const [handlePhoneChange, handleSubmit, handleChange, formData,
        isSending, errors, handleCaptchaChange, recaptchaRef] = Form();

    return (
        <section id={'contact'} className={style['contact']}
            ref={(el) => (elementsRef.current[26] = el)}>

            <div className={style['contact__container']}>
                <h2 className={`${style['contact__title']} 
                ${visibleElements.includes(elementsRef.current[27]) ?
                        style['contact__title--transition'] : ''}`}>
                    Contáctanos
                </h2>

                <div className={style['contact__section']}
                    ref={(el) => (elementsRef.current[27] = el)}>
                    {/* <p className={`${style['contact__description']} 
                    ${visibleElements.includes(elementsRef.current[27]) ?
                            style['contact__description--transition'] : ''}`}>
                        ¡Nos encantaría saber de ti! <br /> Completa el formulario o
                        utiliza los detalles de contacto a continuación.
                    </p> */}
                </div>

                <div className={style['contact__section']}
                    ref={(el) => (elementsRef.current[28] = el)}>
                    <div className={`${style['contact__content']}
                        ${visibleElements.includes(elementsRef.current[28]) ?
                            style['contact__content--transition'] : ''}`}>
                        {/* <form className={style['contact__form']} onSubmit={handleSubmit}>
                            <label htmlFor='name'>Nombre</label>
                            <input type='text' id='name' name='name' placeholder='Tu nombre'
                                value={formData.name} onChange={handleChange} />
                            {errors.name && <p className={style['contact__error']}>{errors.name}</p>}

                            <label htmlFor='email'>Correo Electrónico</label>
                            <input type='text' id='email' name='email' placeholder='Tu correo electrónico'
                                value={formData.email} onChange={handleChange} />
                            {errors.email && <p className={style['contact__error']}>{errors.email}</p>}

                            <label htmlFor='phone'>Teléfono</label>
                            <PhoneInput
                                country={'co'}
                                value={formData.phone}
                                onChange={(phone, country) => handlePhoneChange(phone, country)}
                                inputProps={{
                                    name: 'phone',
                                    placeholder: 'Tu número de teléfono',
                                }}
                                inputClass={style['contact__phone-input-field']}
                                buttonClass={style['contact__phone-input-button']}
                                countryCodeEditable={false}
                            />
                            {errors.phone && (
                                <p className={style['contact__error']}>{errors.phone}</p>
                            )}

                            <label htmlFor='message'>Mensaje</label>
                            <textarea id='message' name='message' placeholder='Tu mensaje'
                                value={formData.message} onChange={handleChange}></textarea>
                            {errors.message && <p className={style['contact__error']}>{errors.message}</p>}

                            <div className={style['contact__recaptcha-container']}>

                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6Ldz4LIqAAAAABW6-4WtgX3WObHNiqDLgeZsQCRo"
                                    onChange={handleCaptchaChange}
                                    size={window.innerWidth < 440 ? "compact" : "normal"}
                                />
                                {errors.captcha && <p className={style['contact__error']}>{errors.captcha}</p>}

                            </div>

                            <button type='submit' className={style['contact__button']}
                                disabled={isSending}>
                                {isSending ? 'Enviando...' : 'Enviar'}
                            </button>
                        </form> */}

                        <div className={style['contact__socials']}>
                            {/* <h4 className={style['contact__title-socials']}>Síguenos:</h4> */}
                            <a href='https://youtube.com/@brokendev?si=Uejw7r5yotxMibfc' target='_blank' aria-label='Youtube'
                                rel='noopener noreferrer'
                                className={`bi bi-youtube ${style['contact__icon']}`}></a>
                            <a href='https://www.facebook.com/profile.php?id=61570838014407' target='_blank' aria-label='Facebook'
                                rel='noopener noreferrer'
                                className={`bi bi-facebook ${style['contact__icon']}`}></a>
                            <a href='https://x.com/brokendevco' target='_blank' aria-label='twitter'
                                rel='noopener noreferrer'
                                className={`bi bi-twitter ${style['contact__icon']}`}></a>
                            {/* <a href='https://instagram.com' target='_blank' aria-label='Instagram'
                                rel='noopener noreferrer'
                                className={`bi bi-instagram ${style['contact__icon']}`}></a>
                            <a href='https://tiktok.com' target='_blank' aria-label='Instagram'
                                rel='noopener noreferrer'
                                className={`bi bi-tiktok ${style['contact__icon']}`}></a> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
